export const drawer = {
  colorScheme: {
    light: {
      background: '{surface.300}',
      color: '{neutral.900}',
      borderColor: '{surface.600}',
    },
    dark: {
      background: '#424657',
      color: 'white',
      border: {
        color: 'none',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
      .p-drawer-right {
      width: 27rem;
      }
    `,
};
